import {
  EventPreparationTeamDetail,
  EventPreparationTeamDetailsSportFactory,
} from './types'

export function eventPreparationTeamDetailsSoccerFactory(): EventPreparationTeamDetailsSportFactory {
  function getDetails(): EventPreparationTeamDetail {
    return {
      buttons: {
        lineups: {
          name: 'Lineups',
          icon: 'users',
        },
        skins: {
          name: 'Skins',
          icon: 'tshirt',
        },
        formation: {
          name: 'Formations',
          icon: 'tshirt',
        },
      },
      hasLineupsSelect: {
        show: true,
        name: 'Has lineups',
      },
    }
  }

  return { getDetails }
}
